import React, { useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Label, Text, Stack } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import _ from 'underscore';

const recommendedTagStyles = {
  padding: '4px 8px',
  background: '#EFF6FC',
  borderRadius: 4,
  color: '#106EBE',
  fontWeight: 600,
  fontSize: 14,
  marginRight: 20,
};

export const TextTitle = (props) => {
  const i18n = useContext(I18nContext);
  const {
    isActive, titleKey, topicKey, icon, iconStyles, iconAltText, as: HeadingComponent, headingClassName, isRecommended, headingRole, headingLevel,
  } = props;
  return (
    <Fragment>
      <Stack>
        <Stack horizontal tokens={{ childrenGap: 14 }}>
          {icon && <img src={icon} alt={iconAltText} style={iconStyles} />}
          <Label className="collapse-title" isActive={isActive}>
            <HeadingComponent
              className={headingClassName}
              {...(_.isEmpty(headingRole) ? {} : { role: headingRole })}
              {...(_.isEmpty(headingLevel) ? {} : { 'aria-level': headingLevel })}
            >
              {i18n.getString(titleKey)}
            </HeadingComponent>
            {topicKey && HelpPopup && <HelpPopup
              topic={topicKey}
              aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: titleKey })}
              i18n={i18n}
            />}
          </Label>
          {isRecommended && (<div className="recommended-tag" style={recommendedTagStyles}>{i18n.getString(_TL_('Recommended'))}</div>)}
        </Stack>
        <Text
          block
          nowrap
          className={classNames(isActive ? 'hide' : '', 'title-text')}
          styles={{
            root: {
              lineHeight: '24px',
              maxWidth: '100%',
              paddingTop: props.details ? '8px' : 0,
            },
          }}
          title={props.details}
        >
          {props.details}
        </Text>
      </Stack>
    </Fragment>
  );
};

TextTitle.propTypes = {
  titleKey: PropTypes.string.isRequired,
  topicKey: PropTypes.string,
  details: PropTypes.string,
  isActive: PropTypes.bool,
  icon: PropTypes.string,
  iconAltText: PropTypes.string,
  as: PropTypes.elementType,
  headingClassName: PropTypes.string,
  iconStyles: PropTypes.shape({}),
  isRecommended: PropTypes.bool,
  headingRole: PropTypes.string,
  headingLevel: PropTypes.string,
};

TextTitle.defaultProps = {
  topicKey: undefined,
  details: '',
  isActive: false,
  icon: undefined,
  iconAltText: '',
  as: 'span',
  headingClassName: '',
  iconStyles: {},
  isRecommended: false,
  headingRole: '',
  headingLevel: '',
};
